import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useProjectReadFacade } from 'redux/project-read/project-read.facade';

export function FpAdminGuard() {
  const { isProjectAdmin } = useProjectReadFacade();

  return isProjectAdmin ? <Outlet /> : <Navigate to="/" replace />;
}
